module.exports = __webpack_public_path__ + "6498debdbd6c4cd33dfb9fb8cef2cba0.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.relic.com/src/img/styles/6_column_large_x1/public/games/sm_image_3.png
// module id = 490
// module chunks = 0